interface EmailsCellProps {
    emails: string[];
    primaryEmail: string;
}

/**
 * Displays emails with primary email highlighted in blue oval
 */
export function EmailsCell({ emails, primaryEmail }: EmailsCellProps) {
    if (emails.length === 0) {
        return <span className="text-sm text-muted-foreground">No emails</span>;
    }

    return (
        <div className="flex flex-wrap gap-1">
            {emails.map((email, idx) => {
                const isPrimary = email === primaryEmail;
                return (
                    <span
                        key={idx}
                        className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${
                            isPrimary
                                ? 'bg-blue-100 text-blue-700 border-blue-300'
                                : 'bg-gray-100 text-gray-600 border-gray-300'
                        }`}
                    >
                        {email}
                    </span>
                );
            })}
        </div>
    );
}
